export const unnecessarySeparator = new RegExp(/\/\/+/, 'g');
